import React from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { EMPTY_OBJECT, PAYMENT_GATEWAY } from '../../constants/globalConstants'
import PaymentGatwayHeartLand from './PaymentGatewayHeartLand'
import PGIframeDC from './PGIframeDC'
import PaymentGatewayStripe from '../../components/stripe/PaymentGatewayStripe'
const DefaultComponent = () => <></>
function PaymentGatewayCommon(props) {
    const {
        onSubmit, faciltyData, isSubmittingForm, page,
        setIsSubmittingForm, amount, consent, prevButton,
        setFormData, formData, loginUser, LoginSignUpButton,
        previousButton, confirmPay, isCheckOutStatus, paymentDisable,
        setValue, customGateWay, APILoad, setupFutureUsage, stripeIntentMode, stripeCaptureMethod, onInvalid
    } = props
    const mainForm = () => {
        return <section>
            {/* Stripe: always its own card fields (is_iframe_enabled does not apply) */}
            {faciltyData?.facility_payment_details?.facility_payment_type_id == PAYMENT_GATEWAY.STRIPE ? <PaymentGatewayStripe
                faciltyData={faciltyData}
                onSubmit={onSubmit}
                isSubmittingForm={isSubmittingForm}
                amount={Number(String(amount || 0).replace(/,/g, ''))}
                intentMode={stripeIntentMode || (page == 'addCard' ? 'setup' : 'payment')}
                setupFutureUsage={setupFutureUsage}
                captureMethod={stripeCaptureMethod}
                page={page}
                consent={consent}
                previousButton={previousButton || prevButton}
                setValue={setValue}
                setFormData={setFormData}
                formData={formData}
                APILoad={APILoad}
                onInvalid={onInvalid}
            /> :
            // Datacap / Heartland iframe only when turned on ('1'); no configuration = card form. Not for Fiserv
            // (CardConnect's own fields), as Stripe above
            (faciltyData?.facility_payment_details?.facility_payment_type_id != PAYMENT_GATEWAY.FISERV && faciltyData?.facility_configuration?.is_iframe_enabled != '1') ? customGateWay :
            faciltyData?.facility_payment_details?.facility_payment_type_id == PAYMENT_GATEWAY.HEARTLAND ? <PaymentGatwayHeartLand
                paymentData={faciltyData}
                onSubmit={onSubmit}
                isSubmittingForm={isSubmittingForm}
                amount={amount}
                consent={consent}
                prevButton={prevButton}
                setFormData={setFormData}
                formData={formData}
                loginUser={loginUser}
                LoginSignUpButton={LoginSignUpButton}
                previousButton={previousButton}
                confirmPay={confirmPay}
                isCheckOutStatus={isCheckOutStatus}
                paymentDisable={paymentDisable}
                page={page}
                setValue={setValue}
            /> :
            faciltyData?.facility_payment_details?.facility_payment_type_id == PAYMENT_GATEWAY.DATACAP ? 
            <PGIframeDC consent={consent} setIsSubmittingForm={setIsSubmittingForm} isSubmittingForm={isSubmittingForm} onSubmit={onSubmit} setValue={setValue} faciltyData={faciltyData} page={page} previousButton={previousButton} setFormData={setFormData} formData={formData} APILoad={APILoad} /> :
                null
            }
        </section>
    }
    return (
        <div>{mainForm()} </div>
    )
}

PaymentGatewayCommon.propTypes = {
    faciltyData: PropTypes.object,
    isSubmittingForm: PropTypes.bool,
    setIsSubmittingForm: PropTypes.func,
    onSubmit: PropTypes.func,
    amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    setupFutureUsage: PropTypes.oneOf(['off_session', null]),
    stripeIntentMode: PropTypes.oneOf(['payment', 'setup']),
    stripeCaptureMethod: PropTypes.oneOf(['manual', 'automatic']),
    onInvalid: PropTypes.func,
    consent: PropTypes.elementType,
    prevButton: PropTypes.elementType,
    setValue: PropTypes.func,
    formData: PropTypes.object,
    setFormData: PropTypes.func,
    loginUser: PropTypes.bool,
    isCheckOutStatus: PropTypes.bool,
    paymentDisable: PropTypes.bool,
    LoginSignUpButton: PropTypes.elementType,
    previousButton: PropTypes.elementType,
    confirmPay: PropTypes.elementType,
    customGateWay: PropTypes.elementType,
    page: PropTypes.string,
    APILoad: PropTypes.oneOfType([
        PropTypes.func, 
        PropTypes.shape({ current: PropTypes.any })
    ])
}

PaymentGatewayCommon.defaulProps = {
    faciltyData: EMPTY_OBJECT,
    isSubmittingForm: false,
    setIsSubmittingForm: noop,
    onSubmit: noop,
    amount: '',
    consent: DefaultComponent,
    prevButton: DefaultComponent,
    setValue: noop,
    formData: EMPTY_OBJECT,
    setFormData: noop,
    loginUser: false,
    isCheckOutStatus: false,
    paymentDisable: false,
    LoginSignUpButton: DefaultComponent,
    previousButton: DefaultComponent,
    confirmPay: DefaultComponent,
    customGateWay: DefaultComponent,
    page: '',
    APILoad: null
}
export default PaymentGatewayCommon